import mitt from 'mitt';

const componentConnection = new mitt();

export default {
  componentConnection
}

